import { useDeliveryApi } from "../../../common/api/delivery-api/useDeliveryApi";

export const useBucketArchiveApi = () => {
    const {
        validateBucketArchiveUniqueId,
        createArchiveBucket,
        getArchiveBucketList,
        importBucketArchive
    } = useDeliveryApi();

    return {
        createArchiveBucket,
        validateBucketArchiveUniqueId,
        getArchiveBucketList,
        importBucketArchive
    };
};
